// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"976a4b50","554":"056e8e80","771":"3729125c"}[chunkId] + ".chunk.css";
};